import { Component, computed, input } from '@angular/core';
import { sonaHlm } from '@sona/angular-util-common';
import { hlm } from '@spartan-ng/brain/core';

import type { ClassValue } from 'clsx';

@Component({
	selector: 'hlm-skeleton',
	standalone: true,
	template: '',
	host: {
		'[class]': '_computedClass()'
	}
})
export class HlmSkeletonComponent {
	public readonly userClass = input<ClassValue>('', { alias: 'class' });
	protected _computedClass = computed(() => {
        return sonaHlm('tw-block tw-animate-pulse tw-rounded-md tw-bg-muted', this.userClass());
    });
}
